import { type Dispatch } from '@reduxjs/toolkit';

import { type ErrorState } from '../types/error';
import { type NotificationMessage } from '../types/notification';

import { addNotification } from './notification';

export function setError(error: ErrorState) {
    return function (dispatch?: Dispatch): void {
        const DEFAULT: ErrorState = {
            error: null,
            source: '',
            notify: error.notify,
            log: false,
            createdAt: new Date(),
        };
        const err = {
            ...DEFAULT,
            ...error,
        };
        if (err.log || process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.error(err.createdAt, err.source, err.error);
        }
        if (dispatch && err.notify && err.error) {
            // Find the error message
            let message = 'Unknown Error';
            if (err.fields?.length) {
                message = err.fields[0] as string;
            } else if (typeof err.error === 'string') {
                message = err.error;
            } else {
                if ('error' in err.error) {
                    const tmpError = err.error.error as Record<string, string> | string;
                    message = typeof tmpError === 'string' ? tmpError : tmpError.detail || tmpError.error;
                } else if ('detail' in err.error) {
                    message = (err.error.detail as string) || (err.error as string);
                }
            }
            let notify: NotificationMessage = {
                message,
                severity: 'error',
            };
            if (typeof err.notify === 'object') {
                notify = {
                    ...notify,
                    ...err.notify,
                    message: err.notify.message || err.error.toString(),
                };
            }
            dispatch(addNotification(notify));
        }
    };
}
